<template>
    
  <div 
      class="modal fade" 
      id="AddUsagerModal" 
      data-bs-backdrop="static" 
      data-bs-keyboard="false" 
      tabindex="-1" 
      aria-hidden="true"
      ref="AddUsagerModalRef"
  > 
    <div class="modal-dialog">
      <div class="modal-content">    
        <div class="modal-header">        
          <h1 class="modal-title fs-5">Usager</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form  ref="usagerForm" @submit="soumettre" :validation-schema="usagerSchema">
          <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Nom <span class="text-danger"></span>
                  </label>
                  <Field
                      name="nom"
                      v-model="nom"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="Renseigner le nom"
                    />
                    <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Prénom <span class="text-danger"></span>
                  </label>
                  <Field
                      name="prenom"
                      type="text"
                      v-model="prenom"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="Renseigner le prénom"
                    />
                    <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group mb-15">
                  <label class="d-block text-black fw-semibold">
                    Date de naissance <span class="text-danger"></span>
                  </label>
                  <Field
                      name="dateNaissance"
                      v-model="dateNaissance"
                      type="date"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="Renseigner votre date de naissance"
                    />
                    <ErrorMessage name="dateNaissance" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    NIP <span class="text-danger"></span>
                  </label>
                  <Field
                      name="npi"
                      v-model="nip"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="Renseigner le NPI"
                    />
                    <ErrorMessage name="npi" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Adresse <span class="text-danger"></span>
                  </label>
                  <Field
                      name="adresse"
                      v-model="adresse"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="Renseigner l'adresse"
                    />
                    <ErrorMessage name="adresse" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Téléphone <span class="text-danger"></span>
                  </label>
                  <Field
                      name="tel"
                      v-model="telephone"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="Renseigner l'adresse"
                    />
                    <ErrorMessage name="tel" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    IFU <span class="text-danger"></span>
                  </label>
                  <Field
                      name="ifu"
                      v-model="ifu"
                      class="form-control shadow-none fs-md-15 text-black"
                      placeholder="XXXXXXXXXXXX"
                    />
                    <ErrorMessage name="ifu" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label fw-medium text-black">
                    Sexe
                  </label>
                  <Field name="sexe" v-slot="{ field }" v-model="sexe">
                    <Multiselect
                      :options="sexes"
                      :searchable="true"
                      v-model="field.value"
                      v-bind="field"
                      placeholder="Sélectionner un sexe"
                    />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
              <button type="submit" class="btn btn-primary w-100">Enregistrer</button>
            </div>
          </div>
          
        </Form>
        </div>    
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref,watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage, useResetForm } from 'vee-validate';
import Multiselect from '@vueform/multiselect'
import {Option} from "@/models/Option";
import { hideModal, showModal, success, error } from '@/utils/utils';
import * as Yup from 'yup';
import axios from 'axios';
import ApiService from '@/services/ApiService';

export default defineComponent({
  name: "AddUsagerModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  props: {
    item: {
      type: String,
      required: true
    },
  },
  setup: (props, { emit }) => {
    const usagerSchema = Yup.object().shape({
      nom: Yup.string().required("Le nom est obligatoire"),
      prenom: Yup.string().required("Le prénom est obligatoire"),
      tel: Yup.string().required("Le numéro de téléphone est obligatoire"),
      sexe: Yup.string().required("Le sexe est obligatoire"),
      adresse: Yup.string().required("L'adresse est obligatoire"),
      ifu: Yup.string().min(13,"Veuillez renseiller au moins 13 caractères").max(13,"Veuillez renseiller un maximum de 13 caractères").required("L'ifu est obligatoire"),
      npi: Yup.string().required("Le NPI est obligatoire"),
      dateNaissance: Yup.date().required("La date de naissance est obligatoire"),
    });
    const usagerForm = ref<any | null>(null);
    const ifu = ref();
    const nom = ref();
    const prenom = ref();
    const nip = ref();
    const dateNaissance = ref();
    const adresse = ref();
    const mois = ref();
    const sexe = ref();
    const matricule = ref<any>(null);
    const telephone = ref();
    const moiss = ref();
    const AddUsagerModalRef = ref<null | HTMLElement>(null);
    const sexes = ref([
      { value: 'Masculin', label: 'Masculin' },
      { value: 'Féminin', label: 'Féminin' },
      { value: 'Autre', label: 'Autre' },
    ]);


    const resetForm = () =>{
      ifu.value = "";
      nom.value = "";
      prenom.value = "";
      nip.value = "";
      adresse.value = null;
      telephone.value = null;
      sexe.value = null;
      dateNaissance.value = null;
      matricule.value = null;
    }
    
    const getUsager = async (matricule: string) => {
      try{
        const response = await axios.get(`usager/${matricule}`);
        if(response.data.data.length > 0){
          const lusager = response.data.data[0];
          ifu.value = lusager.ifu;
          nom.value = lusager.nom;
          prenom.value = lusager.prenom;
          nip.value = lusager.npi;
          adresse.value = lusager.adresse;
          telephone.value = lusager.tel;
          sexe.value = lusager.sexe;
          dateNaissance.value = lusager.dateNaissance; //new Date();
        }else{
          error('Erreur lors de la récupération de l\'usager');
        }
        
      }catch (err){
        //
      }
      
    }

    watch(() => props.item , async (newValue) => {
      if(newValue !== null){
        matricule.value = newValue;
       await getUsager(newValue)
      }else{
        resetForm();
      }
    });

    

    const soumettre = async(values,{resetForm}) => {
      values["matricule"] = matricule.value;
      try{
        const response = await axios.post("usager/creation",values);
        const retour = response.data.data;
        success('L\'usager a été enregistré avec succès');
        emit('recuperation',[{value:retour, label: values.nom + " "+values.prenom + " - "+values.dateNaissance}]);
        resetForm();
        hideModal(AddUsagerModalRef.value);
        emit('close');
      }catch (err) {
        //
      }
    }


    return {props,ifu,nom,prenom,nip,adresse,sexes,sexe,mois,moiss,soumettre,usagerSchema,telephone,usagerForm,dateNaissance };
  }
  
});

</script>

<style src="@vueform/multiselect/themes/default.css"></style>